import dva from 'dva';
import { message } from 'antd';
//import { browserHistory } from 'dva/router';
//import { createBrowserHistory as createHistory } from 'history';
//import modelContainer from './models/container';
import InitApp from './components/InitApp';
//import _ from 'lodash';

// models
//import modelMeta from './models/meta';
//import modelMobile from './models/mobile';
//import modelSchool from './models/school';
//import modelTravel from './models/travel';

// router
import router from './router';
//import router from './pages/index/config/router';
//import routerNews from './pages/news/config/router';
//import routerContact from './pages/contact/config/router';
//import routerMobile from './pages/mobile/config/router';
//import routerSchool from './pages/school/config/router';
//import routerAbout from './pages/about/config/router';
//import routerAd from './pages/ad/config/router';
//import routerTravel from './pages/travel/config/router';

import "./style/global.less";

const appKey = '.app';
/*
const config = {
  travel: {
    model: ['travel'],
  },
  about: {
    model: ['about'],
  },
  default:{
    model: ['meta']
  }
};
*/

try{
  const appContainers = document.querySelectorAll(appKey);

  for(let app of appContainers.values()) {
    let ds = Object.assign({}, app.dataset);

    if (app.id === undefined || ds.key === undefined) {
      throw app.id + " id or data-key is invalid";
    }
//    let models = (config[ds.key])?config[ds.key].model:config.default.model;

    let opt = {
      id: app.id,
      key: ds.key,
      ds: ds,
//      models: models
    };

    InitApp(opt);
  }
}catch(e){
//  message(e, 3);
  console.info(e);
}



/*
const appId  = '#app';
const appKey = '.app';

const od   = document.querySelector(appId);
const appContainers = document.querySelectorAll(appKey);
const container = [];
let models = [];

try {
  if(!od) {
    throw appId+' is not specified in html';
  }
  const ds = od.dataset;

  for(let _app of appContainers.values()) {
    let appds = Object.assign({}, _app.dataset);
    const {key} = appds;
    delete appds.key;

    if (_app.id === undefined || key === undefined) {
      throw _app.id + " id or data-key is invalid";
    }
    let modelMap = (config[key])?config[key].model:config.default.model;
    models = _.concat(models, modelMap);

    container.push({
      id: _app.id,
      key: key,
      target: _app,
      ds: appds
//      meta: meta
    });
  }

  models = _.union(models);

  let initialState = {container: container};

  // 1. Initialize
  const app = dva({
    history: createHistory(),
    initialState: initialState,
    onError(e) {
      console.error(e);
//      alert(e.message);
//      message.error(e.message, 3);
    },
  });


  // 2. Plugins
  //app.use(createLoading());
  // use plugin
  //console.info(app);

  // 3. Model
  app.model(modelContainer);
  if(models) {
     models.map(model => {
      app.model(require('./models/' + model).default);
    });
  }

  // 4. router
//  app.router(router);
  app.router(routerNews);

  console.info('state', initialState);
  console.info('models', models);
  console.info('containers', container);

  // 5. Start
  app.start(appId);

}catch(e){
//  message(e, 3);
  console.info(e);
}
*/
/*
    let meta = {...appds};
    meta.page = (meta.page) ? parseInt(meta.page) : 0;
    meta.test = (meta.test) ? parseInt(meta.test) : 0;
    console.info(appds.id, meta);

    initialState = {...meta};
  */

/*
const models = [];
const callback = (model) => {
//  _.findIndex(models, o => {})
if(_.indexOf(models, model) < 0){
  models.push(model);

  return true;
}else {
  return false;
}
}

*/


/*


  const apps = document.querySelectorAll(appKey);

  if(apps){
    for(let app of apps.values()) {
      let ds = app.dataset;
      if(app.id === undefined || ds.key === undefined){
        throw "id or data-key is invalid";
      }
      const opt = {
        target: app.id,
        models: (modelMap[ds.key])?modelMap[ds.key]:modelMap.default,
      };

      let meta = {...ds};
      meta.page = (meta.page)?parseInt(meta.page):0;
      meta.test = (meta.test)?parseInt(meta.test):0;
      console.info('ds.meta', meta);

      const initialState = {meta: meta};

      // 1. Initialize
      const app = dva({
        history: createHistory(),
        initialState: initialState,
        onError(e) {
          console.error(e);
          alert(e.message);
          message.error(e.message, 3);
t},
});

// 2. Plugins
//app.use(createLoading());

// 3. Model
//    app.model(modelMeta);

if(opt.models) {
  opt.models.map(model => {
//        if(opt.callback('../models/' + model)){
    app.model(require('../models/' + model).default);
//        }
  });
}

// 4. router
app.router(require('../pages/' + ds.key + '/config/router').default);

// 5. Start
app.start(id);

}
}


let target = "#news";
const od = document.querySelector(target);



if(od) {
  const ds = od.dataset;
  const initialState = {};
  const {service} = ds;
  console.info('[Service]', service);

  if(service === 'news'){
    initialState.meta = {
      url: ds.newsurl,
      page: ds.page
    }
  }

  if(service === 'contact'){
    initialState.meta = {...ds}
  }

  if(service === 'about'){
    initialState.meta = {...ds}
  }

  if(service === 'blog'){
    initialState.meta = {...ds}

  }

  if(service === 'mobile'){
    initialState.mobile = {...ds}
  }

  if(service === 'school'){
    initialState.meta = {...ds}
  }

  // 1. Initialize
  const app = dva({
    history: createHistory(),
    initialState: initialState,
    onError(e) {
      console.error(e);
      alert(e.message);
//      message.error(e.message, 3);
    },
  });

  // 2. Plugins
  //app.use(createLoading());

  // 3. Model
  app.model(modelMeta);
  //  app.model(modelMobile);
  if(service === "mobile") {
    app.model(modelMobile);
    app.router(routerMobile);
  }

  if(service === "school") {
    app.model(modelSchool);
    app.router(routerSchool);
  }

  if(service === "contact") {
    app.router(routerContact);
  }

  if(service === "news") {
    app.router(routerNews);
  }

  if(service === "about") {
    app.router(routerAbout);
  }

  if(service === "blog") {
    app.router(routerAd);
  }

  // 5. Start
  app.start(target);
}else{
//  alert(target + " is not set");
  console.error(target + " is not set");
}
*/



// WEBPACK FOOTER //
// ./src/index.js